<template lang="pug">
.stocks-wrap
  .stocks
    .symbol {{ ticker || '...' }}
    .ranges
      .range(v-for="([k, limit]) in Object.entries({ '1m': 30, '3m': 90, '6m': 180, '1y': 365, '2y': 730, '5y': 1825, 'max': 100000 }).filter(([k, v]) => v * millisInADay < oldestEntry || k === 'max')",
             @click="days = limit"
             :class="{ selected: days === limit }") {{ k }}
    .price(v-if="today.price") ${{ today.price.toFixed(2) }}
    .growth-rate(v-if="growthRate")
      span.up(v-if="growthRate * 1 > 0") &uarr;
      span.down(v-else) &darr;
      span.value {{ growthRate.replace(/^\-/, '') }}
      span.percent %
    keep-alive
      canvas.ohlc(ref="ohlc", width="600", height="275")
    //ohlc(:chart-data="chartData")
</template>
<script>
import { Chart, BarController, LineController, LineElement, PointElement, BarElement, LinearScale, TimeScale, CategoryScale } from 'chart.js';
import 'chartjs-adapter-moment';
//import ohlc from './ohlc';
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed } from '../../helpers';
let ohlc;
export default {
  name: 'stocks',
  data() {
    return {
      today: {},
      days: 30,
      results: null,
      chartData: {
        datasets: [
          {
            label: 'Series 1',
            backgroundColor: '#f87979',
            data: [{
              o: 350,
              h: 360,
              l: 345,
              c: 350,
              t: new Date('2019-01-10').getTime(),
            },
              {
                o: 350,
                h: 370,
                l: 340,
                c: 360,
                t: new Date('2019-01-11').getTime(),
              },
              {
                o: 360,
                h: 370,
                l: 355,
                c: 355,
                t: new Date('2019-01-12').getTime(),
              },
              {
                o: 355,
                h: 380,
                l: 360,
                c: 370,
                t: new Date('2019-01-13').getTime(),
              },
              {
                o: 370,
                h: 365,
                l: 340,
                c: 350,
                t: new Date('2019-01-14').getTime(),
              }],
          },
        ]
      }
    };
  },
  props: {
    ticker: {
      type: String,
      default() {
        return (/\;tk\=([^\;]+)/.exec(location.href) || [])[1] || 'AAPL';
      }
    }
  },
  watch: {
    days(newValue) {
      return this.renderChart();
      const { results, millisInADay } = this;
      // const { chartData, days } = this;
      // const now = new Date() * 1;
      // const millisInADay = 86400000;
      // return chartData?.filter(({ t }) => now - t < millisInADay * days);
      console.log('watch days', newValue, ohlc);
      //ohlc.data.datasets
      const [highLows, openCloses] = ohlc.data.datasets;//.map(({ data }) => data);
      // console.log('highLows', highLows);
      const now = new Date() * 1;
      // const millisInADay = 86400000;
      const { days } = this;
      // const days = 180;
      const filteredResults = results.filter(({ t }) => now - t < millisInADay * days);
      ohlc.data.labels = filteredResults.map(({ td }) => td);
      //highLows.data = days > 30 && [] || filteredResults.map(({ h, l }) => [h, l]);
      //const hld = highLows.data = filteredResults.map(({ h, l }) => [h, l]);
      highLows.data = filteredResults.map(({ h, l }) => [h, l]);
      //console.log('watch days', highLows.data, highLows.data.length);
      //const ocd = openCloses.data = filteredResults.reduce((all, { o, c, td }) => {
      openCloses.data = filteredResults.reduce((all, { o, c, td }) => {
        all.push({ y: o, x: td });
        all.push({ y: c, x: td });
        return all;
      }, []);
      //ohlc.config.data = { ...ohlc.config.data, datasets: [{ ...highLows, data: hld }, { ...openCloses, data: ocd }]};
      // console.log('trying update...');
      ohlc.update();
      // console.log('...updated');
      // highLows
    },
    ticker() {
      console.log('ticker watch');
      this.renderChart();
    }
  },
  computed: {
    //...mapGetters(['customThemes', 'selectedThemes', 'documentsSort', 'skimmerSort', 'themes', 'robo', 'folderLiteCache', 'analytics', 'chartShown', 'hoverTheme']),
    ...mapGetters(['engage', 'publishers', 'refPubInfo', 'engageSection', 'selectedWatchlistDocTypes', 'engageSelectedThemes', 'engageMaxAges']),
    ...vuexComputed('engageStockOverview', 'engageFullHoldings', 'engageHoldingsGroupedByTicker', 'engageFundGrowthRate'),
    inScene() {
      const { ticker, engage } = this;
      return engage.ticker !== ticker;
    },
    millisInADay() {
      return 86400000;
    },
    oldestEntry() {
      const { results } = this;
      let r = results?.[results?.length - 1].t * 1;
      return (r && new Date() - r) || 0;
    },
    growthRate() {
      const { today, days } = this;
      const map = {
        30: 'oneMonthGrowthRateLabel',
        90: 'threeMonthsGrowthRateLabel',
        180: 'sixMonthsGrowthRateLabel',
        365: 'oneYearGrowthRateLabel',
        730: 'twoYearsGrowthRateLabel',
        1825: 'fiveYearsGrowthRateLabel',
        100000: 'maxGrowthRateLabel'
      };
      return (today?.[map[days]] || '').replace(/\%$/, '');
    },
    filtered() {
      const { chartData, days } = this;
      const now = new Date() * 1;
      const millisInADay = 86400000;
      return chartData?.filter(({ t }) => now - t < millisInADay * days);
    }
  },
  methods: {
    ...mapActions(['loadEngageRoboReport', 'toggleEngageSelectedDocument', 'toggleEngageSelectedPublisher', 'toggleSelectedWatchlistDocType', 'toggleEngageSelectedTheme']),
    async renderChart(mounting) {
      //const ticker = 'STNC';
      // const ticker = 'TSLA';
      const { ticker, engage, inScene } = this;
      // const ticker = (/\;tk\=([^\;]+)/.exec(location.href) || [])[1] || 'AAPL';
      // const ticker = 'F';
      //console.log('renderChart ticker', ticker, inScene);
      const url = `https://d3vcdcoa0cytwv.cloudfront.net/api/GetHistoricalTickerInfo?t=${ ticker }&v=b${ inScene && '&so=1' || '' }`;
      // const url = `https://d3vcdcoa0cytwv.cloudfront.net/api/GetRealTimeOrLastTradeTickerInfo?t=${ ticker }&foo=2`;
      //console.log('stocks mounted...', url);
      const response = await fetch(url);
      const json = await response.json();
      // console.log('...stocks mounted', json);
      const { results, lastTradeSummary, summary, stockOverview: so } = json;
      this.engageStockOverview = Object.freeze(so || {});
      this.results = Object.freeze(results);
      window.lts = this.lastTradeSummary = lastTradeSummary;
      this.today = { ...summary, ...lts, so };
      if (!inScene) {
        this.engageFundGrowthRate = summary.maxGrowthRateLabel;
      }
      const now = new Date() * 1;
      const millisInADay = 86400000;
      const { days } = this;
      // const days = 180;
      const filteredResults = results.filter(({ t }) => now - t < millisInADay * days);
      const brn = '#8D6E4F';
      let shouldUpdate = false;
      const oldestDate = new Date(now - millisInADay * days);
      console.log(oldestDate);
      // oldestDate.setFullYear(2012)
      if (inScene) {
        console.log('inScene renderChart', mounting);
        const { ticker: et } = engage
        if (!this.engageFullHoldings && et) {
          const url = `https://api.weave.ai/cs/engage/min-fund-holdings/${ et }.json`;
          // const url = `https://d3vcdcoa0cytwv.cloudfront.net/api/GetRealTimeOrLastTradeTickerInfo?t=${ ticker }&foo=2`;
          //console.log('stocks mounted...', url);
          const response = await fetch(url);
          const json = await response.json();
          console.log('...stocks mounted fund holdings', json);
          const { fullHoldings } = json;
          if (fullHoldings) {
            console.log('dispatch full holdings');
            await (this.engageFullHoldings = fullHoldings);
            //console.log('add fund holdings', data.datasets.length, data.datasets);
            // const filteredHoldings = Object.entries(fullHoldings).filter(([t]) => now - t < millisInADay * days);
            // console.log('filteredHoldings', Object.entries(fullHoldings).length, filteredHoldings.length);
            // this.engageStockOverview = Object.freeze(so || {});
            // this.results = Object.freeze(results);
            //const filteredResults = results.filter(({ t }) => now - t < millisInADay * days);
          } else {
            console.log('no full holdings');
          }
        }
      }
      const { earningsCalendar: ec } = so || {};
      const data = {
        labels: filteredResults.map(({ td }) => td),
        datasets: [
          {
            label: 'high and lows',
            // data: [] || filteredResults.map(({ h, l }) => [h, l]),
            data: filteredResults.map(({ h, l }) => [h, l]),
            backgroundColor: brn + '77',
            barThickness: 2,
            borderWidth: 0,
            borderRadius: 0.5,
            order: 1
          },
          {
            label: 'opens and closes',
            type: 'line',
            data: filteredResults.reduce((all, { o, c, td }) => {
              all.push({ y: o, x: td });
              all.push({ y: c, x: td });
              return all;
            }, []),
            order: 0,
            borderColor: brn + '22',
            // backgroundColor: ['transparent', 'orange'],
            //pointBorderColor: [brn + '99', brn],
            // pointBorderColor: [brn, 'orange'],
            pointBorderColor: filteredResults.map(() => 'black'),
            pointBackgroundColor: 'transparent',
            // pointBackgroundColor: '#28282844',
            // pointBorderColor: 'transparent',
            borderWidth: 1,
            // pointRadius: [4, 2],
            // pointRadius: 10,
            // pointBorderWidth: 3,
            // pointStyle: 'rectRounded',
            //pointStyle: 'line',
            pointStyle: filteredResults.map(() => 'line'),
            //borderDash: [5, 5]
            // pointStyle: ['line', 'rectRounded'],
            // tension: 0,
            // tension: 0.35
          }
          /*,
          {
            label: 'opens',
            type: 'line',
            data: filteredResults.map(({ o }) => o),
            backgroundColor: 'red',
            pointBorderColor: 'red',
            borderWidth: 1,
            // tension: 0,
            tension: 0.35
          }*/
        ]
      };
      if (inScene) {
        const { engageHoldingsGroupedByTicker } = this;
        // console.log('engageFullHoldings should be ready if true', inScene, this.engageFullHoldings, engageHoldingsGroupedByTicker);
        if (engageHoldingsGroupedByTicker && (true || data.datasets.length < 3)) {
          // console.log('push fund holdings in render chart mounting', mounting, engageHoldingsGroupedByTicker?.[ticker], data.datasets.length, engageHoldingsGroupedByTicker?.[ticker]
            //?.filter(({ time }) => now - time < millisInADay * days)
            // ?.map(({ percent, td, time }) => ({ x: td, y: (now - time < millisInADay * days) ? percent : -100 })));
          data.datasets.push({
            // label: `${ ticker } percentage`,
            label: 'stock percentage',
            yAxisID: 'y1',
            type: 'line',
            lineTension: 0.4,
            order: 2,
            // stepped: true,
            data:
              engageHoldingsGroupedByTicker?.[ticker]
                ?.filter(({ time }) => now - time < millisInADay * days)
                ?.map(({ percent, td }) => ({ x: td, y: percent })) || [],
            borderColor: brn + 'ff',
            pointBorderColor: brn + '22',
            pointBackgroundColor: 'transparent',
            borderWidth: 1,
            pointRadius: 1,
          });
          const tickerLine = ticker => {
            return {
              label: `${ ticker } percentage`,
              yAxisID: 'y1',
              type: 'line',
              lineTension: 0.4,
              order: 0,
              // stepped: true,
              data:
                engageHoldingsGroupedByTicker?.[ticker]
                  ?.filter(({ time }) => now - time < millisInADay * days)
                  ?.map(({ percent, td }) => ({ x: td, y: percent })) || [],
              borderColor: brn + '15',
              pointBorderColor: brn + '22',
              pointBackgroundColor: 'transparent',
              borderWidth: 1,
              pointRadius: 0
            };
          };
          //todo: change this to use engagePubContext
          Object.keys(engageHoldingsGroupedByTicker).forEach(ticker => {
            data.datasets.push(tickerLine(ticker));
          });
          shouldUpdate = true;
        }
      }
      if (mounting) {
        const ctx = this.$refs.ohlc.getContext('2d');
        Chart.register(BarController, BarElement, LineController, LineElement, PointElement, LinearScale, TimeScale, CategoryScale);
        window['ohlc_' + (engage.ticker === ticker && ticker || 'scene')] = ohlc = new Chart(ctx, {
          type: 'bar',
          data,
          options: {
            responsive: true,
            plugins: {
              legend: {
                display: false
              }
            },
            NOTanimation: {
              onComplete() {
                console.log('animation onComplete', ohlc, ohlc?.ctx);
                // const { ctx } = ohlc.chart;
                const { ctx, data } = ohlc;
                if (ctx && data) {
                  // ctx.font = this.scale.font;
                  const { datasets } = data;
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'bottom';
                  const dataset = datasets[1];
                  // datasets.forEach((dataset, i) => {
                  console.log('fillText', dataset); //, dataset.fillColor);
                  ctx.fillStyle = brn; //dataset.fillColor;
                  dataset.data.forEach(points => {
                    console.log('fillText', points);
                    ctx.fillText('hello', 65, 52);
                    // ctx.fillText('hello', points.x, 52);
                  });
                  // });
                }
              }
            },
            /*tooltips: {
              callbacks: {
                label(tooltipItem, data) {
                  let r = data.datasets[tooltipItem.datasetIndex].r || '';

                  if (r) {
                    r += ': ';
                  }
                  r += Math.round(tooltipItem.yLabel * 100) / 100;
                  return r;
                }
              }
            },
            interaction: {
              intersect: false,
              mode: 'index'
            },
            elements: {
              point: {
                DpointBorderColor(context) {
                  let r;
                  const { x, y } = context.parsed;
                  if (ohlc) {

                  }
                  console.log('elements pointBorderColor backgroundColor', x, y, ohlc, context);
                  // r = context.createLinearGradient(x - 3, y, x + 3, y);
                  // r.addColorStop(0, 'blue');
                  // r.addColorStop(0.25, 'white');
                  // r.addColorStop(0.75, 'white');
                  // r.addColorStop(1, 'yellow');
                  return r || 'blue';
                }
              }
            },*/
            scales: {
              // lineWidth: false,
              y: {
                beginAtZero: false,
                position: 'right',
                ticks: {
                  color: brn + 'aa'
                },
                grid: {
                  display: false,
                  color: '#fafafa',
                  tickColor: brn,
                  drawBorder: false
                }
              },
              y1: {
                max: 20, //todo: change to dynamic value based on data
                min: 0,
                beginAtZero: true,
                position: 'left',
                ticks: {
                  // color: brn + 'aa'
                  color: 'transparent'
                },
                grid: {
                  stacked: true,
                  display: false,
                  color: '#fafafa',
                  tickColor: brn,
                  drawBorder: false
                }
              },
              xAxis: {
                // The axis for this scale is determined from the first letter of the id as `'x'`
                // It is recommended to specify `position` and / or `axis` explicitly.
                type: 'time',
                min: oldestDate,
                ticks: {
                  color: brn + 'aa'
                },
                grid: {
                  display: false
                }
              }
            }
          }
        });
        // if (inScene) {
        //   const url = `https://api.weave.ai/cs/engage/min-fund-holdings/${ engage.ticker }.json`;
        //   // const url = `https://d3vcdcoa0cytwv.cloudfront.net/api/GetRealTimeOrLastTradeTickerInfo?t=${ ticker }&foo=2`;
        //   //console.log('stocks mounted...', url);
        //   const response = (await fetch(url));
        //   const json = (await response.json());
        //   console.log('...stocks mounted fund holdings', json);
        //   const { fullHoldings } = json;
        //   if (fullHoldings) {
        //     await (this.engageFullHoldings = fullHoldings);
        //     console.log('add fund holdings', ohlc.data.datasets.length, ohlc.data.datasets);
        //     if (ohlc.data.datasets.length < 3) {
        //       ohlc.data.datasets.push({
        //         label: 'fund holdings',
        //         yAxisID: 'y1',
        //         type: 'line',
        //         data: engageHoldingsGroupedByTicker?.[ticker]?.map(({ percent, td }) => ({ x: td, y: percent })) || [],
        //         borderColor: brn + 'aa',
        //         pointBorderColor: 'black',
        //         pointBackgroundColor: 'transparent',
        //         borderWidth: 1,
        //         pointRadius: 0
        //         // scales: {
        //         //   y: {
        //         //     beginAtZero: false,
        //         //     position: 'left',
        //         //     ticks: {
        //         //       color: brn + 'aa'
        //         //     },
        //         //     grid: {
        //         //       display: true,
        //         //       color: '#fafafa',
        //         //       tickColor: brn,
        //         //       drawBorder: false
        //         //     }
        //         //   }
        //         // }
        //       });
        //     }
        //     // const filteredHoldings = Object.entries(fullHoldings).filter(([t]) => now - t < millisInADay * days);
        //     // console.log('filteredHoldings', Object.entries(fullHoldings).length, filteredHoldings.length);
        //     // this.engageStockOverview = Object.freeze(so || {});
        //     // this.results = Object.freeze(results);
        //     //const filteredResults = results.filter(({ t }) => now - t < millisInADay * days);
        //   }
        // }
        if (shouldUpdate) {
          //console.log('shouldUpdate', shouldUpdate);
          ohlc.update();
        }
      } else {
        const [highLows, openCloses, fundHoldings] = window['ohlc_' + (engage.ticker === ticker && ticker || 'scene')]?.data?.datasets || [];
        const [hls, ocs, fhs] = data.datasets || [];
        if (ohlc) {
          ohlc.data.labels = data.labels;
          ohlc.options.scales.xAxis.min = oldestDate;
        }
        const hideDetails = days > 90;
        if (highLows) {
          highLows.data = hls.data;
          highLows.hidden = hideDetails;
        }
        if (openCloses) {
          openCloses.data = ocs.data;
          openCloses.pointBorderColor = (hideDetails && 'transparent') || 'black';
          openCloses.borderColor = brn + ((!hideDetails && '22') || '');
          if (ec) {
            // console.log('ec!', ec, hideDetails, filteredResults);
            const dates = Object.entries(ec).reduce((map, [date, earning]) => {
              const key = date.replace(/T.*$/, '');
              map[key] = [];
              map[key].push(earning);
              return map;
            }, {});
            // console.log('filtered results hits', filteredResults.map(({ td }) => dates[td.replace(/T.*$/, '')]), dates);
            //console.log('ec length', filteredResults.filter(({ td }) => dates[td.replace(/T.*$/, '')]));
            openCloses.pointBorderColor = filteredResults.map(({ td }) => {
              const [earning] = dates[td.replace(/T.*$/, '')] || [];
              // console.log('pointBorderColor', earning, earning?.surprisePercent);
              return (
                (earning?.surprisePercent > 0 && 'orange') ||
                (earning && brn) ||
                (hideDetails && 'transparent') ||
                'black'
              );
            });
            openCloses.pointStyle = filteredResults.map(({ td }) => {
              return (dates[td.replace(/T.*$/, '')] && 'circle') || 'line';
            });
            openCloses.pointLabel = filteredResults.map(({ td }) => {
              return (dates[td.replace(/T.*$/, '')] && 'circle') || 'line';
            });
            openCloses.pointRadius = filteredResults.map(({ td }) => {
              const [earning] = dates[td.replace(/T.*$/, '')] || [];
              const abs = Math.abs(earning?.surprisePercent || 0);
              return (abs > 50 && 10) || (abs > 10 && 6) || (earning && 4) || 2;
            });
            openCloses.pointBorderWidth = filteredResults.map(({ td }) => {
              return (dates[td.replace(/T.*$/, '')] && 3) || 1;
            });
            openCloses.pointBackgroundColor = filteredResults.map(({ td }) => {
              const [earning] = dates[td.replace(/T.*$/, '')] || [];
              const abs = Math.abs(earning?.surprisePercent || 0);
              const neg = earning?.surprisePercent < 0;
              return ((neg && brn) || earning && '#ffffff' + ((abs > 10 && 'bb') || '77')) || (hideDetails && 'transparent') || 'black';
            });
            /*console.log(Object.entries(ec).map(([date, earnings]) => {
              const td = date.replace(/T.*$/, '');
              const hit = filteredResults.find(result => td === result.td.replace(/T.*$/, ''));
              return { date, hit };
            }));*/
          }
        }
        if (fhs?.data?.length && fundHoldings) {
          fundHoldings.data = fhs.data;
        }
        const { engageHoldingsGroupedByTicker } = this;
        if (engageHoldingsGroupedByTicker) {
          // console.log('renderChart datasets length', (window['ohlc_' + (engage.ticker === ticker && ticker || 'scene')]?.data?.datasets)?.length);
          Object.keys(engageHoldingsGroupedByTicker).forEach((ticker, index) => {
            const ds = (window['ohlc_' + (engage.ticker === ticker && ticker || 'scene')]?.data?.datasets)?.[index + 3];
            if (ds) {
              ds.data = data.datasets[index].data;
            }
          });
          console.log('fundHoldings fhs', data.datasets.length, fundHoldings, fhs, fhs === fundHoldings);
          if (fhs && !fundHoldings) {
            window['ohlc_' + (engage.ticker === ticker && ticker || 'scene')]?.data?.datasets.push(fhs);
          }
        }
        ohlc.update();
      }
    }
  },
  // components: { viewer: () => import('@/components/topo-components/viewer'), reportCard, reportOpener, clipboard, highlighter } //,
  // components: { ohlc },
  mounted() {
    this.renderChart(true);
  },
  async NOTmounted() {
    //const ticker = 'STNC';
    // const ticker = 'TSLA';
    const { ticker } = this;
    // const ticker = (/\;tk\=([^\;]+)/.exec(location.href) || [])[1] || 'AAPL';
    // const ticker = 'F';
    const url = `https://d3vcdcoa0cytwv.cloudfront.net/api/GetHistoricalTickerInfo?t=${ ticker }&foo=2`;
    //console.log('stocks mounted...', url);
    const response = (await fetch(url));
    const json = (await response.json());
    //console.log('...stocks mounted', json);
    const { results, lastTradeSummary, summary } = json;
    this.results = Object.freeze(results);
    window.lts = this.lastTradeSummary = lastTradeSummary;
    this.today = { ...summary, ...lts };
    const now = new Date() * 1;
    const millisInADay = 86400000;
    const { days, engage } = this;
    // const days = 180;
    const filteredResults = results.filter(({ t }) => now - t < millisInADay * days);
    const ctx = this.$refs.ohlc.getContext('2d');
    Chart.register(BarController, BarElement, LineController, LineElement, PointElement, LinearScale, TimeScale, CategoryScale);
    const brn = '#8D6E4F';
    window['ohlc_' + (engage.ticker === ticker && ticker || 'scene')] = ohlc = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: filteredResults.map(({ td }) => td),
        datasets: [
          {
            label: 'high and lows',
            data: filteredResults.map(({ h, l }) => [h, l]),
            backgroundColor: brn + '77',
            barThickness: 2,
            borderWidth: 0,
            borderRadius: 0.5
          },
          {
            label: 'opens and closes',
            type: 'line',
            data: filteredResults.reduce((all, { o, c, td }) => {
              all.push({ y: o, x: td });
              all.push({ y: c, x: td });
              return all;
            }, []),
            borderColor: brn + '22',
            // backgroundColor: ['transparent', 'orange'],
            //pointBorderColor: [brn + '99', brn],
            // pointBorderColor: [brn, 'orange'],
            pointBorderColor: 'black',
            pointBackgroundColor: 'transparent',
            // pointBorderColor: 'transparent',
            borderWidth: 1,
            //pointRadius: [3, 6],
            pointStyle: 'line',
            //borderDash: [5, 5]
            // pointStyle: ['line', 'rectRounded'],
            // tension: 0,
            // tension: 0.35
          }
          /*,
          {
            label: 'opens',
            type: 'line',
            data: filteredResults.map(({ o }) => o),
            backgroundColor: 'red',
            pointBorderColor: 'red',
            borderWidth: 1,
            // tension: 0,
            tension: 0.35
          }*/
        ]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false
          }
        },
        /*tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              let r = data.datasets[tooltipItem.datasetIndex].r || '';

              if (r) {
                r += ': ';
              }
              r += Math.round(tooltipItem.yLabel * 100) / 100;
              return r;
            }
          }
        },
        interaction: {
          intersect: false,
          mode: 'index'
        },
        elements: {
          point: {
            DpointBorderColor(context) {
              let r;
              const { x, y } = context.parsed;
              if (ohlc) {

              }
              console.log('elements pointBorderColor backgroundColor', x, y, ohlc, context);
              // r = context.createLinearGradient(x - 3, y, x + 3, y);
              // r.addColorStop(0, 'blue');
              // r.addColorStop(0.25, 'white');
              // r.addColorStop(0.75, 'white');
              // r.addColorStop(1, 'yellow');
              return r || 'blue';
            }
          }
        },*/
        scales: {
          // lineWidth: false,
          y: {
            beginAtZero: false,
            position: 'right',
            ticks: {
              color: brn + 'aa'
            },
            grid: {
              display: false,
              color: '#fafafa',
              tickColor: brn,
              drawBorder: false
            }
          },
          xAxis: {
            // The axis for this scale is determined from the first letter of the id as `'x'`
            // It is recommended to specify `position` and / or `axis` explicitly.
            type: 'time',
            ticks: {
              color: brn + 'aa'
            },
            grid: {
              display: false
            }
          }
        }
      }
    });
  }
};
</script>
<style lang="scss" scoped>
@import '../../scss/global';
.stocks-wrap {
  .stocks {
    //display: ;
    /*position: fixed;
    top: 5rem;
    bottom: 1rem;
    //left: 21vw;
    left: 51vw;
    //width: 76vw;
    width: 46vw;*/
    position: absolute;
    top: 1.5rem;
    z-index: 1;
    width: 36rem;
    background-color: rgba(white, 0.5);
    transition: background-color 250ms ease-in-out;
    &:hover {
      background-color: white;
    }
    //height: 23rem;
    //max-width: 100vw;
    //min-height: 10vh;
    //width: 100vw;
    border: 1px solid #dadada;
    border-radius: 0.5rem;
    //box-shadow: 1px 1px 3px black;
    //border-radius: 0.25rem;
    //transform: translate3d(-110vw, 0, 0);
    //transform-origin: top left;
    //transition: transform 700ms ease-in-out;
    //will-change: transform;
    //z-index: -1;
    //cursor: default;
    //transform: none;
    box-sizing: border-box;
    padding: 3.5rem 1rem 0.5rem;

    &.shown {
      //transform: none;
    }
    & > .symbol {
      position: absolute;
      top: 0.5rem;
      left: 0.5rem;
      color: $brn;
      font-size: 2rem;
      font-weight: 200;
      font-family: 'Assistant', sans-serif;
      text-transform: uppercase;
    }
    & > .price {
      position: absolute;
      //top: 0.8rem;
      //right: 10.75rem;
      top: 3rem;
      left: 0.25rem;
      color: $brn;
      font-size: 1.5rem;
      font-weight: 200;
      font-family: 'Assistant', sans-serif;
      text-transform: uppercase;
      background-color: white;
      padding: 0 0.25rem;
      border-radius: 0.25rem;
    }
    & > .growth-rate {
      position: absolute;
      top: 0.75rem;
      right: 1rem;
      box-sizing: border-box;
      padding: 0 0.25rem;
      color: $brn;
      font-size: 1.5rem;
      font-weight: 200;
      font-family: 'Assistant', sans-serif;
      text-transform: uppercase;
      border-radius: 0.25rem;
      background-color: rgba($brn, 0.06125);
      & > .value {
        display: inline-block;
        min-width: 5.2rem;
        text-align: right;
      }
      & > .up,
      & > .down {
        font-family: 'Trebuchet MS';
        font-weight: 100;
        margin-right: 0.25rem;
        position: relative;
        top: 0.125rem;
      }
    }
    & > .ranges {
      position: absolute;
      top: 0.875rem;
      left: 6.875rem;
      //padding: 1rem;
      background-color: white;
      display: grid;
      grid-template-columns: repeat(7, 2.25rem);
      grid-column-gap: 0.25rem;
      padding: 0.125rem;
      border-radius: 0.25rem;
      & > .range {
        cursor: pointer;
        box-sizing: border-box;
        padding: 0.125rem 0;
        text-align: center;
        color: $brn;
        border: 2px solid #efefef;
        border-radius: 0.25rem;
        font-weight: 200;
        font-family: 'Assistant', sans-serif;
        text-transform: uppercase;
        transition: all 250ms ease-in-out;
        &:hover,
        &.selected {
          //font-weight: 400;
          color: black;
          border-color: #ccc;
        }
      }
    }
    & > .ohlc {
      transform: scale(1);
      transform-origin: top left;
    }
    & > .opener {
      cursor: pointer;
      display: none;
      position: fixed;
      top: 1rem;
      left: 110%;
      //margin-left: 3rem;
      //transform: translate3d(5.5rem, 0, 0);
      transform: translate3d(-2rem, 0, 0);
      font-size: 2rem;
      padding: 0.25rem 0.125rem;
      /*border-top-right-radius: 0.25rem;*/
      /*border-bottom-right-radius: 0.25rem;*/
      border-radius: 0.25rem;
      color: white;
      background-color: $brn;
      opacity: 0.75;
      transition: opacity 250ms ease-in-out 1500ms;
      will-change: opacity;
      &:hover {
        opacity: 1;
      }
    }
    &:not(.shown) > .opener {
      display: block;
      transition-delay: 10ms;
    }
    & > .banner {
      display: grid;
      //grid-template-columns: 60% 39.5%;
      grid-template-columns: 50% 49.5%;
      grid-column-gap: 0.5%;
      width: 100vw;
      .view-mode {
        position: absolute;
        top: 1.4rem;
        right: 0.5rem;
        width: 6.5rem;
        height: 2rem;
        //outline: 1px solid blue;
        opacity: 0;
        pointer-events: none;
        transition: opacity 250ms ease-in-out;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: 0.25rem;
        //background-color: #efefef;
        border-radius: 0.25rem;
        //padding: 0.125rem;
        border: 1px solid rgba($brn, 0.5);
        $padding: 0.125rem;
        & > * {
          cursor: pointer;
          position: relative;
          background-color: white;
          box-sizing: border-box;
          opacity: 0.5;
          border-radius: 0.25rem;
          overflow: hidden;
          //border: 1px solid #efefef;
          &.on,
          &:hover {
            opacity: 1;
          }
          &::before {
            position: absolute;
            top: $padding;
            left: $padding;
            bottom: $padding;
            width: 30%;
            content: '';
            background-color: #ccc;
            box-sizing: border-box;
            border: 1px solid white;
            border-top-left-radius: 0.25rem;
            border-bottom-left-radius: 0.25rem;
          }
          &::after {
            position: absolute;
            top: $padding;
            right: $padding;
            bottom: $padding;
            width: 30%;
            content: '';
            background-color: #ccc;
            box-sizing: border-box;
            border: 1px solid white;
            border-top-right-radius: 0.25rem;
            border-bottom-right-radius: 0.25rem;
          }
        }
        .a-b {
          //background-color: red;
          &:after {
            width: 65%;
            background-color: $brn;
          }
        }
        .a-b-c {
          &::before {
            //width: 20%;
          }
          .v {
            position: absolute;
            top: 0.2rem;
            left: 38%;
            right: 30%;
            bottom: 0.2rem;
            background-color: $brn;
            //background-color: blue;
          }
          //background-color: blue;
        }
        .b-c {
          &::before {
            width: 65%;
            background-color: $brn;
          }
          //background-color: green;
        }
      }
      &.has-viewer {
        grid-template-columns: 20% 55% 19.5%;
        grid-column-gap: 3rem;
        &.ab {
          grid-template-columns: 20% 74.5%;
          .publishers-section {
            display: none;
          }
        }
        &.bc {
          grid-template-columns: 74.5% 20%;
          .key-documents {
            display: none;
          }
        }
        .view-mode {
          opacity: 1;
          pointer-events: all;
        }
        .publishers-section {
          .publishers {
            grid-template-columns: repeat(3, 3rem);
            max-height: calc(100vh - 7.5rem);
            overflow-y: auto;
          }
        }
        & > .key-documents {
          display: flex;
          flex-wrap: wrap;
          max-height: calc(100vh - 7.5rem);
          overflow-y: auto;
          & > .key-document {
            &.has-pages {
              width: 21.5rem;
              &.two-pages {
                .pages {
                  grid-template-columns: repeat(1, 6rem);
                }
              }
            }
          }
        }
      }
      & > .publisher {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: -1;
        .bg {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: no-repeat center;
          background-position-y: -15rem;
          background-attachment: fixed;
          background-size: 80%;
          opacity: 0.15;
        }
      }
      & > .key-documents {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        //grid-column-gap: 0.5rem;
        //display: flex;
        //flex-wrap: wrap;
        .key-document {
          cursor: pointer;
          position: relative;
          height: 22rem;
          background-color: rgba(white, 0.7);
          border: 4px solid rgba($brn, 0.25);
          //box-shadow: 0 0 6px rgba($brn, 0.1);
          border-radius: 0.25rem;
          box-sizing: border-box;
          padding: 0.5rem 0.25rem 1rem 14rem;
          margin-right: 2.1rem;
          margin-bottom: 2rem;
          &:hover {
            & > .date {
              opacity: 1;
            }
          }
          &.has-pages {
            width: 26rem;
            &.two-pages {
              .pages {
                grid-template-columns: repeat(1, 1fr);
                //grid-template-columns: repeat(1, 8rem);
              }
            }
            .pages {
              display: grid;
            }
            & > .title {
              right: 11.75rem;
            }
          }
          & > .title {
            position: absolute;
            top: 0.5rem;
            left: 0.25rem;
            right: 0.25rem;
            text-align: center;
            color: $brn;
            font-size: 0.8rem;
            text-transform: uppercase;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            //overflow: hidden;
            //text-overflow: ellipsis;
            //white-space: nowrap;
            //transform: translate3d(-50%, 0, 0);
            //font-size: 1.4rem;
            z-index: 1;
          }
          .date {
            position: absolute;
            bottom: 0.5rem;
            left: 0.5rem;
            color: $brn;
            font-size: 0.8rem;
            //text-transform: uppercase;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            opacity: 0;
            transition: opacity 600ms ease-in-out 400ms;
          }
          & > .bg {
            position: absolute;
            top: 2rem;
            left: 0;
            width: 14rem;
            height: 18rem;
            background: no-repeat center white;
            background-size: contain;
          }
          .pages {
            display: none;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 0.5rem;
            border-left: 3px solid rgba($brn, 0.35);
            height: 19.5rem;
            align-content: start;
            padding: 0.25rem;
            overflow-y: auto;
            .page {
              cursor: pointer;
              position: relative;
              padding-top: 136%;
              .bg {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                background: no-repeat center white;
                background-size: contain;
              }
            }
          }
        }
      }
      .publishers-section {
        //position: absolute;
        //top: 0;
        //left: 0;
        //bottom: 0;
        //right: 50vw;
        z-index: 1;
        .publishers {
          box-sizing: border-box;
          padding: 0.5rem;
          display: grid;
          //grid-template-columns: repeat(7, 3rem);
          grid-template-columns: repeat(7, 5.5rem);
          //grid-gap: 0.25rem;
          //grid-gap: 3rem;
          grid-gap: 2rem;
          z-index: 1;
          .publisher {
            position: relative;
            padding-top: 100%;
            .bg {
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              background: no-repeat center;
              background-size: contain;
            }
          }
        }
      }
    }
    & > .items {
      max-width: 100vw;
      box-sizing: border-box;
      padding: 1rem;
      display: grid;
      grid-template-columns: repeat(24, 1fr);
      grid-column-gap: 0.1rem;
      //grid-column-gap: 2rem;
      grid-row-gap: 2rem;
      & > .item {
        cursor: pointer;
        box-sizing: border-box;
        padding: 0.25rem;
        border: 2px solid #f5f5f5;
        border-radius: 0.125rem;
        background-color: white;
        transition: all 200ms ease-in-out;
        will-change: all;
        transform-origin: center;
        &.full {
          border-color: orange;
          z-index: 1;
          transform: scale(1.2);
        }
        &.before {
          transform: scale(0.9) translate3d(0.4rem, 0, 0);
        }
        &.after {
          transform: scale(0.9) translate3d(-0.4rem, 0, 0);
        }
        &.on {
          border-color: orange;
        }
        & > .bg {
          padding-top: 100%;
          background: white no-repeat center;
          background-size: contain;
        }
      }
    }
    & > .sorter {
      position: absolute;
      top: 0;
      left: 0;
    }
    //&.open {
    .heading {
      font-size: 1.5rem;
      font-weight: 200;
      position: absolute;
      top: 0.25rem;
      left: 0.5rem;
      opacity: 0.4;
      transition: opacity 250ms ease-in-out;
      will-change: opacity;
    }
    .folders {
      & > .heading {
        color: $brn;
        opacity: 1;
        font-size: 2rem;
        left: 1rem;
      }
      .items {
        display: grid;
        pointer-events: all;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: auto;
        grid-row-gap: 1.25rem;
        padding-right: 20rem;
        //grid-template-columns: repeat(4, 1fr);
        //grid-template-columns: repeat(7, 1fr);
        //overflow: auto;
        //max-height: calc(100vh - 6rem);
      }
    }
    .close {
      pointer-events: all;
      display: block;
    }
    .count {
      display: none;
    }
    //}
    .count {
      position: absolute;
      top: 0;
      left: 100%;
      transform: translate3d(0.5rem, 0, 0);
    }
    .close {
      display: none;
      position: absolute;
      top: 0.25rem;
      right: 0.25rem;
      height: 3rem;
      width: 3rem;
      &:hover {
        &::after {
          color: black;
        }
      }
      &::after {
        color: #dadada;
        cursor: pointer;
        content: '\00d7';
        position: absolute;
        top: -0.3rem;
        right: -0rem;
        font-size: 1.25rem;
        //margin-top: -0.05rem;
        //transform: translate3d(0, -70%, 0);
      }
    }
  }
  & > .exit-sections-wrapper {
    position: absolute;
    top: 8rem;
    right: 4rem;
    z-index: 17;
    max-height: 50vh;
    overflow: auto;
    transform: rotate3d(1, 1, 0, 90deg);
    transition: transform 400ms ease-in-out;
    //transform: translate3d(0, 0, 0);
    &.shown {
      transform: none;
      //transform: translate3d(0, 0, 0);
    }
    & > .close {
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1.3rem;
      padding: 0.25rem 0.5rem 1.25rem 0.75rem;
      //background-color: lightskyblue;
      color: $brn;
      opacity: 0.5;
      transition: opacity 250ms ease-in-out;
      &:hover {
        opacity: 1;
      }
    }
    .exit-sections {
      .sub-section {
        padding: 1rem 2rem 2rem;
        padding-bottom: 1rem;
        border: 1px solid $brn;
        box-shadow: 1px 1px 3px $brn;
        border-radius: 0.5rem;
        background-color: white;
        & > .title {
          text-align: center;
          font-weight: 300;
          font-size: 0.9rem;
          text-transform: uppercase;
          color: $brn;
          margin-bottom: 0.5rem;
        }
        a.link {
          display: block;
          background-color: white;
          text-decoration: none;
          border: 2px solid transparent;
          border-radius: 0.5rem;
          transition: border-color 250ms ease-in-out;
          &:hover {
            border-color: rgba($brn, 0.5);
          }
          &.people {
            display: grid;
            padding: 1rem;
            grid-template-columns: 5rem 15rem;
            grid-column-gap: 1rem;
            & > .bg {
              height: 5rem;
              grid-row: 1 / 3;
              border-radius: 100%;
              background: #efefef no-repeat center;
              background-size: cover;
            }
            & > .title {
              text-align: left;
              font-weight: 300;
              font-size: 1.5rem;
              text-transform: uppercase;
              color: $brn;
              grid-column: 2 / 3;
              grid-row: 1 / 2;
            }
            & > .titles {
              grid-column: 2 / 3;
              grid-row: 2 / 3;
              display: flex;
              flex-wrap: wrap;
              //padding: 1rem;
              & > .tag {
                white-space: nowrap;
                margin: 0.125rem;
                font-size: 0.7rem;
                text-transform: uppercase;
                color: $brn;
                &:last-of-type {
                  &::after {
                    display: none;
                  }
                }
                &::after {
                  content: ', ';
                  font-size: 1.1rem;
                  line-height: 0.8rem;
                  color: rgba($brn, 0.8);
                }

              }
            }
          }
        }
      }
    }
  }
  & > .sections-wrap {
    position: fixed;
    bottom: 0.5rem;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    transition: opacity 250ms ease-in-out;
    z-index: 5;
    &.hide {
      opacity: 0;
      pointer-events: none;
    }
    .sections {
      //display: flex;
      display: grid;
      grid-gap: 1rem;
      justify-content: space-evenly;
      //height: 6rem;
      background-color: rgba($brn, 0.6);
      border-radius: 0.25rem;
      box-shadow: 0 0 3px $brn;
      padding: 1rem 2rem;
      &.has-selection {
        .section {
          opacity: 0.7;
          &:hover,
          &.selected {
            opacity: 1;
          }
        }
      }
      .section {
        cursor: pointer;
        position: relative;
        transform-origin: top right;
        text-transform: uppercase;
        font-size: 1.2rem;
        font-weight: 500;
        white-space: nowrap;
        box-sizing: border-box;
        text-align: center;
        //height: 1rem;
        background-color: white;
        color: $brn;
        border: 1px solid rgba($brn, 0.5);
        padding: 0.5rem 0.75rem 0.5rem 4rem;
        border-radius: 0.25rem;
        transition: all 250ms ease-in-out;
        &:hover,
        &.selected {
          border-color: $brn;
          box-shadow: 0 0 2px $brn;
        }
        .for-videos {
          position: absolute;
          top: 0.5rem;
          left: 2.25rem;
          width: 2rem;
          height: 2rem;
          background: no-repeat top left
            url("data:image/svg+xml;charset%3Dutf8,%3Csvg version%3D'1.1' xmlns%3D'http://www.w3.org/2000/svg' xmlns:xlink%3D'http://www.w3.org/1999/xlink' x%3D'0px' y%3D'0px' viewbox%3D'0 0 512 512' xml:space%3D'preserve' preserveaspectratio%3D'xMinYMin meet' width%3D'100%' height%3D'100%' style%3D'fill: %238D6E4F;'%3E%3Cpath transform%3D'scale(0.04)' d%3D'M265,96c65.3,0,118.7,1.1,168.1,3.3l0.7,0h0.7c23.1,0,42,22,42,49.1v1.1l0.1,1.1c2.3,34,3.4,69.3,3.4,104.9v0v0 c0.1,35.6-1.1,70.9-3.4,104.9l-0.1,1.1v1.1c0,13.8-4.7,26.6-13.4,36.1c-7.8,8.6-18,13.4-28.6,13.4h-0.8l-0.8,0c-52.9,2.5-108.8,3.8-166.4,3.8c-3.5,0-7.1,0-10.6,0H256h-0.1c-3.6,0-7.2,0-10.8,0c-57.8,0-113.7-1.3-166.2-3.7l-0.8,0h-0.8 c-10.6,0-20.7-4.8-28.5-13.4c-8.6-9.5-13.4-22.3-13.4-36.1v-1.1l-0.1-1.1c-2.4-34.1-3.5-69.4-3.3-104.7v-0.1v-0.1 c-0.1-35.3,1-70.5,3.3-104.6l0.1-1.1v-1.1c0-27.2,18.8-49.3,41.9-49.3H78l0.7,0c49.5-2.3,102.9-3.3,168.2-3.3h9H265 M265,64 c-3,0-6,0-9,0s-6,0-9,0c-57.6,0-114.2,0.8-169.6,3.3c-40.8,0-73.9,36.3-73.9,81.3C1,184.4-0.1,220,0,255.7c-0.1,35.7,0.9,71.3,3.4,107c0,45,33.1,81.6,73.9,81.6c54.8,2.6,110.7,3.8,167.8,3.8c3.6,0,7.3,0,10.9,0c3.6,0,7.2,0,10.7,0c57.1,0,113-1.2,167.9-3.8c40.9,0,74-36.6,74-81.6c2.4-35.7,3.5-71.4,3.4-107.1c0.1-35.7-1-71.3-3.4-107.1c0-45-33.1-81.1-74-81.1 C379.2,64.8,322.7,64,265,64L265,64z'%3E%3C/path%3E%3C/svg%3E");
          background-size: contain;
          opacity: 0.3;
          &.on {
            opacity: 1;
          }
          &::after {
            content: '';
            position: absolute;
            top: 0.425rem;
            left: 0.5rem;
            height: 0;
            width: 0;
            border: 0.2rem solid transparent;
            border-left-width: 0.4rem;
            border-left-color: $brn;
          }
        }
        .for-documents {
          position: absolute;
          top: 0.6rem;
          left: 0.75rem;
          transform: scale(0.25);
          transform-origin: top left;
          opacity: 0.4;
          pointer-events: none;
          &.on {
            opacity: 1;
          }
        }
      }
    }
  }
  .section-viewer-wrap {
    $blind-duration: 750ms;
    position: fixed;
    top: 50vh;
    left: 0;
    right: 0;
    height: calc(100vh - 4.25rem);
    max-height: 0;
    overflow: hidden;
    pointer-events: none;
    transition: all $blind-duration ease-out;
    z-index: 4;
    &.shown {
      top: 4.25rem;
      max-height: calc(100vh - 4.25rem);
      pointer-events: all;
      & > .section-viewer {
        transform: translate3d(0, 0, 0);
      }
    }
    .section-viewer {
      position: absolute;
      top: 0;
      left: 0;
      bottom: -50vh;
      right: 0;
      transform: translate3d(0, -50vh, 0);
      transition: all $blind-duration ease-out;
      will-change: transform;
      overflow: auto;
      background-color: $brn;
      padding-right: 18.25rem;
      &.pdf-mode {
        padding-right: 0.5rem;
        .widgets {
          .insights-documents {
            grid-template-columns: 1fr 4.5fr 1fr;
            .viewer {
              overflow: hidden;
              overflow-y: auto;
              grid-column: 2 / 3;
              grid-row: 1 / 3;
            }
            .documents {
              display: block;
              margin-top: 2rem;
              grid-row: 1 / 3;
              & > .document {
                transform: translate3d(2.25rem, 0, 0);
                float: none;
              }
            }
          }
          .insights-publishers {
            margin-top: 0 !important;
          }
          .videos {
            opacity: 0;
            pointer-events: none;
          }
        }
      }
      & > .title {
        position: fixed;
        top: 0.25rem;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        text-align: center;
        margin-left: -9.75rem;
        z-index: 100;
        box-sizing: border-box;
        padding: 0.25rem 0.5rem;
        background-color: rgba($brn, 0.8);
        border-bottom-left-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;
        &.left {
          //margin-left: -12.75rem;
          margin-left: -9.75rem;
        }
        color: white;
        font-size: 2rem;
        font-weight: 500;
      }
      .widgets {
        &.has-videos {
          //padding-right: 12.75rem;
          .videos {
            //display: grid;
          }
        }
        .themes-section {
          //position: absolute;
          //top: 0;
          //left: 0;
          //right: 0;
          position: relative;
          top: 0;
          transform: translate3d(0, 4.85rem, 0);
          grid-column: 2 / 3;
          height: 11.75rem;
          margin: -2.2rem 0 -10rem;
          //background-color: lightskyblue;
          background-color: white;
          border-bottom: 6px solid rgba($brn, 0.5);
          z-index: 2;
          & > .title {
            text-align: left;
            margin-left: 0.5rem;
            text-transform: uppercase;
            line-height: 2rem;
            font-family: 'Assistant', sans-serif;
            font-size: 1.1rem;
            color: $brn;
          }
          .selected-themes {
            .selected-theme {
            }
          }
          & > .themes {
            position: absolute;
            left: 0;
            width: 100%;
            height: 9.5rem;
            display: flex;
            justify-content: flex-start;
            overflow: hidden;
            overflow-x: auto;
            .theme {
              cursor: pointer;
              position: relative;
              flex-shrink: 0;
              width: 5rem;
              height: 9.5rem;
              margin: 0;
              box-sizing: border-box;
              &.selected {
                .bg {
                  border-color: orange;
                }
              }
              &:first-of-type {
                margin-left: 0;
              }
              &:last-of-type {
                margin-right: 0;
              }
              //padding-top: 150%;
              //outline: 1px solid blue;
              &:hover {
                .title {
                  //opacity: 1;
                }
              }
              .title {
                cursor: default;
                position: absolute;
                bottom: 0.5rem;
                //left: -60%;
                //right: -60%;
                left: 0;
                right: 0;
                text-align: center;
                //font-size: 1.1rem;
                font-size: 0.8rem;
                //font-weight: 600;
                font-family: 'Assistant', sans-serif;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                color: $brn;
                //opacity: 0;
                //transition: opacity 250ms ease-in-out;
                z-index: 1;
                //border-radius: 0.5rem;
                background-color: rgba(white, 0.65);
                box-shadow: 0 0 3px white, 0 0 6px white;
                /*text-shadow: 1px 1px 0 white,
                             -1px -1px 0 white,
                             0 1px 0 white,
                             1px 0 0 white,
                             0 -1px 0 white,
                             -1px 0 1px white;*/
              }
              .bg {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 2rem;
                right: 0;
                background: white center no-repeat;
                background-image: url('https://media.gettyimages.com/photos/pedestrian-crosses-a-bridge-in-front-novartis-ags-headquarters-in-picture-id137642112?b=1&k=6&m=137642112&s=612x612&w=0&h=qsND2vg0XhyJ72PcirzKiEB-wlynGpgvmtlSS_51EWI=');
                background-size: cover;
                border: 3px solid transparent;
              }
            }
          }
        }
        .insights-documents {
          display: grid;
          grid-row-gap: 1.2rem;
          padding: 0.5rem;
          grid-template-columns: 1fr 3fr;
          grid-template-rows: 12rem 1fr;
          grid-column-gap: 0.5rem;
          height: calc(100vh - 5.25rem);
          & > .viewer {
            background-color: transparent;
          }
          .insights {
            position: relative;
            top: 1px;
            grid-row: 1 / 3;
            background-color: white;
            box-sizing: border-box;
            padding: 3rem 0.5rem 1rem 1.5rem;
            margin-top: 2.6rem;
            //border-top: 2.7rem solid $brn;
            height: calc(100% - 2.6rem);
            &.has-filters {
              & > .scroll-wrap {
                padding-top: 5.75rem;
              }
              & > .filter {
                top: 4rem;
              }
              & > .title {
                padding-bottom: 4.75rem;
              }
            }
            //overflow: auto;
            .scroll-wrap {
              position: absolute;
              top: 2rem;
              left: 0;
              right: 0;
              bottom: 0;
              overflow: auto;
              padding-top: 3.75rem;
              padding-left: 1.5rem;
            }
            & > .max-age {
              cursor: pointer;
              position: absolute;
              top: 2.6rem;
              left: 0.5rem;
              right: 0.5rem;
              display: flex;
              justify-content: flex-start;
              z-index: 2;
              color: $brn;
              text-transform: uppercase;
              font-family: Assistant, Roboto, sans-serif;
              font-weight: 400;
              font-size: 0.75rem;
              .max-ages {
                position: absolute;
                top: -0.75rem;
                //left: -0.3rem;
                left: 0;
                width: 6rem;
                height: 0.5rem;
                z-index: 15;
                //background-color: mediumpurple;
                .age {
                  //cursor: pointer;
                  position: absolute;
                  top: 0.25rem;
                  left: 0;
                  height: 0.25rem;
                  //background-color: #ccc;
                  &.on {
                    background-color: orange;
                    &:after {
                      background-color: orange;
                    }
                  }
                  &:after {
                    position: absolute;
                    content: '';
                    top: -0.125rem;
                    left: 100%;
                    width: 0.125rem;
                    //height: 0.65rem;
                    height: 0.5rem;
                    border-radius: 0.125rem;
                    box-sizing: border-box;
                    //border: 1px solid $brn;
                    background-color: $brn;
                    background-color: orange;
                    z-index: -1;
                  }
                }
              }
            }
            & > .filter {
              position: absolute;
              top: 2.5rem;
              left: 0.5rem;
              //width: 14rem;
              z-index: 2;
              label {
                input {
                  border: 1px solid #efefef;
                  line-height: 1.4rem;
                  padding-right: 1rem;
                  color: $brn;
                  &:focus {
                    border-color: #9a9a9a;
                    outline: none;
                  }
                }
              }
              .close {
                position: absolute;
                top: 0;
                right: 0.5rem;
                cursor: pointer;
              }
            }
            & > .doc-types {
              position: absolute;
              top: 2.125rem;
              right: 0.5rem;
              width: 14rem;
              z-index: 2;
              //display: flex;
              //grid-auto-columns: 20%;
              display: grid;
              //justify-content: flex-start;
              grid-template-columns: 15rem;
              //grid-template-columns: repeat(6, 1.5rem);
              grid-column-gap: 0.125rem;
              grid-row-gap: 1.5rem;
              box-sizing: border-box;
              pointer-events: none;
              opacity: 0;
              transition: all 250ms ease-in-out;
              max-height: 0;
              padding: 1.5rem 0.5rem 0 0.25rem;
              overflow: hidden;
              //background-color: white;
              border: 1px solid transparent;
              border-radius: 0.25rem;
              //&.has-overflow:hover {
              &:hover {
                max-height: 100vh;
                border-color: #dadada;
                background-color: white;
                padding-bottom: 1.5rem;
                & > .doc-type {
                  pointer-events: all;
                  opacity: 0.5;
                  &.on {
                    opacity: 1;
                  }
                }
              }
              &.shown {
                pointer-events: all;
                opacity: 1;
              }
              & > .title {
                cursor: default;
                position: absolute;
                top: 0.25rem;
                left: 0.25rem;
                color: $brn;
                text-transform: capitalize;
                font-family: Assistant, Roboto, sans-serif;
                font-weight: 400;
                font-size: 0.9rem;
                &[resetable] {
                  cursor: pointer;
                  &::after {
                    content: '';
                    position: absolute;
                    bottom: 100%;
                    left: 100%;
                    transform: translate3d(-0.25rem, 0.25rem, 0);
                    width: 0.3rem;
                    height: 0.3rem;
                    border-radius: 50%;
                    background-color: orange;
                  }
                }
              }
              &::after {
                position: absolute;
                top: 0.45rem;
                right: 0.5rem;
                content: 'all types';
                color: $brn;
                text-transform: uppercase;
                font-family: Assistant, Roboto, sans-serif;
                font-weight: 400;
                font-size: 0.7rem;
              }
              &.has-selection {
                &::after {
                  content: attr(count) ' types selected';
                }
                &[count="1"]:after {
                  content: '1 type selected';
                }
                &:hover {
                  & > .doc-type {
                    &.on {
                      opacity: 1;
                      &::after {
                        opacity: 1;
                      }
                    }
                  }
                }
              }
              & > .doc-type {
                cursor: pointer;
                position: relative;
                //margin: 0 0.125rem;
                opacity: 0;
                padding-left: 2rem;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                text-align: left;
                pointer-events: none;
                font-family: Assistant, Roboto, sans-serif;
                &.on {
                  //opacity: 1;
                  &::after {
                    opacity: 0;
                  }
                }
                &:hover {
                  opacity: 1;
                }
                &::after {
                  content: '';
                  position: absolute;
                  top: 50%;
                  left: 1rem;
                  transform: translate3d(0, -50%, 0);
                  width: 0.45rem;
                  height: 0.45rem;
                  background-color: orange;
                  border-radius: 0.125rem;
                  opacity: 0;
                  transition: opacity 250ms ease-in-out;
                }
              }
            }
            & > .title {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              //position: fixed;
              //top: 3.5rem;
              //left: 1rem;
              box-sizing: border-box;
              padding: 0.25rem 0.5rem;
              padding-bottom: 2.75rem;
              background-color: white;
              border-radius: 0.5rem;
              z-index: 1;
              text-align: center;
              text-transform: capitalize;
              font-size: 1.4rem;
              font-weight: 500;
              white-space: nowrap;
              color: $brn;
            }
            .item-wrap {
              display: block;
              text-decoration: inherit !important;
              color: inherit !important;
            }
            .no-results {
              position: absolute;
              top: 7rem;
              left: 0;
              right: 0;
              z-index: 5;
              font-weight: 200;
              font-size: 1.2rem;
              color: $brn;
              text-transform: uppercase;
            }
            .item {
              border: 1px solid #efefef;
              position: relative;
              text-align: left;
              cursor: pointer;
              //height: auto;
              height: 8.5rem;
              padding: 0.5rem 3rem 1rem 3rem;
              margin-bottom: 1.25rem;
              margin-right: 0.75rem;
              &:hover {
                & > .date {
                  opacity: 1;
                }
              }
              & > .copy {
                position: absolute;
                right: 0.5rem;
                top: -1rem;
              }
              & > .text {
                position: relative;
                max-height: 9.5rem;
                overflow: auto;
                //background: linear-gradient(0, white, rgba(green, 0) 20%) no-repeat;
                .keyword {
                  color: $brn;
                }
              }
              & > .publisher {
                position: absolute;
                bottom: 2.5rem;
                right: 0.5rem;
                & > .bg {
                  width: 2rem;
                  height: 2rem;
                  background: center white no-repeat;
                  background-size: contain;
                }
              }
              & > .document {
                position: absolute;
                top: -1rem;
                left: -1rem;
                padding: 0.125rem;
                border: 1px solid #ccc;
                & > .bg {
                  width: 3rem;
                  height: 4.25rem;
                  background: center white no-repeat;
                  background-size: contain;
                }
              }
              & > .date {
                pointer-events: none;
                position: absolute;
                bottom: 0.0625rem;
                right: 0.0625rem;
                padding: 0.125rem;
                background-color: rgba(255, 255, 255, 0.85);
                border-radius: 0.125rem;
                border: 1px solid #f9f9f9;
                font-size: 0.8rem;
                z-index: 4;
                opacity: 0;
                transition: opacity 250ms ease-in-out;
              }
            }
          }
          .documents {
            height: 100%;
            //background-color: red;
            //background-color: rgba(white, 0.7);
            //border: 4px solid rgba($brn, 0.25);
            //box-shadow: 0 0 6px rgba($brn, 0.1);
            //border-radius: 0.25rem;
            grid-row: 2 / 3;
            box-sizing: border-box;
            padding: 0.25rem;
            padding-top: 2.25rem;
            //margin-right: 2.1rem;
            //margin-bottom: 2rem;
            //display: flex;
            //flex-wrap: wrap;
            //justify-content: flex-start;
            //align-items: flex-start;
            overflow: auto;
            &.has-selection {
              .document {
                opacity: 0.75;
                &.selected {
                  border-color: orange;
                  opacity: 1;
                }
                &:hover {
                  opacity: 1;
                }
              }
            }
            .document {
              cursor: pointer;
              $height: 17.5rem;
              $width: 7 / 9 * $height;
              position: relative;
              width: $width;
              height: $height;
              margin: 0.25rem;
              float: left;
              //margin-right: 0;
              border: 0.25rem solid transparent;
              transition: all 250ms ease-in-out;
              & > .title {
                position: absolute;
                bottom: 0;
                left: 0;
              }
              & > .bg {
                position: absolute;
                top: 0;
                left: 0;
                width: $width;
                height: $height;
                background: no-repeat center white;
                background-size: contain;
              }
            }
          }
          .insights-publishers {
            position: relative;
            grid-row: 2 / 3;
            box-sizing: border-box;
            padding: 0.5rem;
            padding-top: 5.5rem;
            //margin-top: 12.25rem;
            background-color: white;
            border-top: 2.7rem solid $brn;
            overflow: hidden;
            overflow-y: auto;
            //display: grid;
            //grid-template-columns: repeat(7, 3rem);
            //display: flex;
            //flex-wrap: wrap;
            //justify-content: flex-start;
            //align-items: flex-start;
            //grid-gap: 0.25rem;
            //grid-gap: 3rem;
            z-index: 1;
            &.has-selection {
              .selected-insights-publishers {
                border-bottom-color: orange;
              }
              .insights-publisher {
                opacity: 0.5;
                &.selected {
                  border-color: orange;
                  opacity: 1;
                }
                &:hover {
                  opacity: 1;
                }
              }
            }
            .selected-insights-publishers {
              position: absolute;
              top: 0.5rem;
              left: 0.5rem;
              right: 0.5rem;
              box-sizing: border-box;
              height: 4.5rem;
              //padding-bottom: 0.5rem;
              border-bottom: 2px solid transparent;
              transition: all 250ms ease-in-out;
              .insights-publisher {
                opacity: 1;
              }
            }
            .insights-publisher {
              cursor: pointer;
              float: left;
              //align-self: flex-start;
              position: relative;
              box-sizing: border-box;
              width: 3.5rem;
              height: 3.5rem;
              margin: 0.25rem;
              //padding-top: 100%;
              border: 0.25rem solid transparent;
              transition: all 250ms ease-in-out;
              &.big {
                width: 8rem;
                height: 8rem;
                margin: 0.4rem;
              }
              .bg {
                position: absolute;
                top: 0.125rem;
                left: 0.125rem;
                bottom: 0.125rem;
                right: 0.125rem;
                background: no-repeat center;
                background-size: contain;
              }
            }
          }
        }
        .videos {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          width: 17.75rem;
          background-color: white;
          padding: 0.25rem;
          padding-top: 4rem;
          //display: none;
          display: grid;
          grid-row-gap: 0.25rem;
          height: calc(100vh - 9rem);
          overflow: auto;
          transition: opacity 250ms ease-in-out;
          & > .title {
            position: absolute;
            top: 2.5rem;
            left: 0;
            right: 0;
            text-align: center;
            text-transform: capitalize;
            font-size: 1.4rem;
            font-weight: 500;
            white-space: nowrap;
            color: $brn;
          }
          a.video {
            position: relative;
            display: inline-block;
            //width: 22%;
            padding-top: 1.35%;
            margin: 1rem 1.5%;
            transition: transform 250ms ease-in-out;
            will-change: transform;
            &:not([draggable="true"]):hover {
              z-index: 3;
              .bg {
                transform: translate3d(0, 95%, 0);
              }
              .info {
                opacity: 1;
              }
            }
            &.playing {
              .bg {
                &::after {
                  position: absolute;
                  top: 0;
                  left: 0;
                  bottom: 0;
                  right: 0;
                  content: '\00a0';
                  background: rgba(40, 40, 40, 0.4) center no-repeat
                  url("data:image/svg+xml;charset%3Dutf8,%3Csvg height%3D'6.827in' viewBox%3D'0 0 6.827 6.827' width%3D'6.827in' xmlns%3D'http://www.w3.org/2000/svg'%3E%3Cpath fill%3D'white' d%3D'M2.83373 4.08723c0.234571,-0.12152 0.468327,-0.242677 0.702075,-0.363862 0.229406,-0.118933 0.458823,-0.237913 0.689008,-0.357299 -0.255059,-0.133181 -0.508724,-0.265543 -0.762114,-0.397764 -0.209614,-0.109378 -0.419059,-0.218677 -0.628969,-0.328256l0 1.44718zm0.750823 -0.26928c-0.259551,0.134563 -0.51911,0.269091 -0.779783,0.404118l-0.0777087 0.040252 0 -0.0875433 0 -1.62249 0 -0.0877638 0.0779173 0.0406811c0.236012,0.123224 0.471343,0.246024 0.706886,0.368933 0.283362,0.147858 0.567059,0.295898 0.852677,0.445059l0.0905591 0.0472953 -0.0907677 0.0470787c-0.260673,0.135205 -0.520232,0.269819 -0.77978,0.404378z'/%3E%3Cpath fill%3D'white' d%3D'M5.83278 4.58511c-0.0327126,0.14115 -0.106701,0.263898 -0.20726,0.355248 -0.101142,0.091874 -0.229165,0.152126 -0.369209,0.16763 -0.305,0.0341142 -0.612587,0.0512874 -0.921185,0.0598937 -0.306618,0.00855118 -0.614535,0.00855118 -0.921929,0.00837402 -0.307256,0.000177165 -0.615177,0.000177165 -0.921839,-0.00837402 -0.308642,-0.0086063 -0.616319,-0.0257795 -0.921354,-0.0598937 -0.140071,-0.0155039 -0.268122,-0.0757756 -0.36922,-0.167677 -0.100508,-0.0913583 -0.174394,-0.214094 -0.206894,-0.355201 -0.0436378,-0.189098 -0.0654331,-0.386354 -0.0763071,-0.584752 -0.0109252,-0.199445 -0.0109291,-0.395992 -0.0109291,-0.586795 0,-0.191055 0.000279528,-0.387858 0.0114685,-0.587185 0.0111457,-0.198484 0.0332087,-0.395748 0.0768228,-0.584815 0.0323071,-0.141047 0.106157,-0.263748 0.206673,-0.35511 0.101157,-0.0919528 0.229335,-0.15226 0.369445,-0.167764 0.304996,-0.0341181 0.612673,-0.0512913 0.921315,-0.0599016 0.306665,-0.00855118 0.614587,-0.00855118 0.921799,-0.00837402 0.307256,-0.000177165 0.615197,-0.000177165 0.921823,0.00837402 0.308606,0.00861024 0.616193,0.0257835 0.921016,0.0599016 0.140244,0.0154961 0.268476,0.0757756 0.369728,0.167689 0.100626,0.0913504 0.174594,0.214075 0.207094,0.355185 0.0859488,0.37402 0.0859488,0.779492 0.0859409,1.16233l0.000208661 0 0 0.00967323 -0.000208661 0c1.5748e-005,0.192681 -7.48031e-005,0.391154 -0.0108425,0.586795 -0.0109134,0.19839 -0.0327126,0.395646 -0.0761575,0.584752zm-0.278929 0.2765c0.0849961,-0.0772126 0.147535,-0.180961 0.175181,-0.300248 0.0419449,-0.182579 0.0630433,-0.373945 0.0736535,-0.566839 0.0107638,-0.19563 0.0108543,-0.391161 0.0108425,-0.580961l-0.000208661 0 0 -0.00967323 0.000208661 0c3.93701e-006,-0.376594 7.87402e-006,-0.775457 -0.083437,-1.13858 -0.0274685,-0.119264 -0.0899803,-0.222992 -0.175016,-0.300185 -0.0849213,-0.0770866 -0.19235,-0.12763 -0.309728,-0.140602 -0.30328,-0.0339488 -0.607673,-0.0509882 -0.91226,-0.0594843 -0.306567,-0.00854724 -0.613094,-0.00854724 -0.918909,-0.00837402 -0.305772,-0.000173228 -0.61228,-0.000173228 -0.918886,0.00837402 -0.304618,0.00849606 -0.609102,0.0255394 -0.912559,0.0594843 -0.117224,0.0129724 -0.224587,0.0635433 -0.309445,0.140677 -0.0848898,0.0771614 -0.14728,0.180858 -0.174594,0.30011 -0.0421299,0.182626 -0.0634843,0.373984 -0.0743189,0.566902 -0.0107835,0.192075 -0.0110512,0.389496 -0.0110512,0.58135 0,0.191677 0,0.38913 0.0105118,0.580961 0.0105709,0.192882 0.0316654,0.384244 0.0738031,0.566839 0.0274724,0.119291 0.0899055,0.22302 0.174815,0.300201 0.0847992,0.0770866 0.192043,0.127618 0.30922,0.140591 0.303492,0.0339449 0.607976,0.0509843 0.912598,0.0594764 0.306602,0.00854724 0.61311,0.00854724 0.918925,0.00837402 0.305953,0.000173228 0.612457,0.000173228 0.919016,-0.00837402 0.304579,-0.00849213 0.608972,-0.0255354 0.912429,-0.0594764 0.117157,-0.0129724 0.224382,-0.0634882 0.309209,-0.140543z'/%3E%3C/svg%3E");
                  background-size: 8rem;
                }
              }
            }
            .bg {
              will-change: transform;
              transition: transform 250ms ease-in-out;
              transform: translate3d(0, 0, 0);
              border-radius: 3px;
              box-shadow: 0 0 5px #989898, 0 0 15px #989898;
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              background: white no-repeat center;
              background-size: cover;
              .duration {
                position: absolute;
                bottom: 0.5rem;
                left: 3rem;
                color: white;
                text-shadow: 1px 1px 1px #black,
                -1px -1px 1px #black,
                -1px 1px 1px #black,
                1px -1px 1px #black
                1px 1px 1px #black,
                -1px -1px 1px #black,
                -1px 1px 1px #black,
                1px -1px 1px #black;

              }
              .source {
                position: absolute;
                left: 0.5rem;
                bottom: 0.5rem;
                height: 2rem;
                width: 2rem;
                background: no-repeat center;
                background-size: contain;
                border-radius: 50%;
              }
            }
            .info {
              box-sizing: border-box;
              padding: 0.25rem;
              border: 1px solid #ccc;
              border-radius: 4px;
              opacity: 0;
              will-change: opacity;
              transition: opacity 250ms ease-in-out;
              z-index: -1;
              position: absolute;
              top: 0.5rem;
              left: 0.5rem;
              bottom: 0.5rem;
              right: 0.5rem;
              .bap {
                cursor: pointer;
                position: absolute;
                bottom: 3rem;
                left: 0;
                right: 0;
                height: 5rem;
                background: no-repeat center bottom
                url("data:image/svg+xml;charset%3Dutf8,%3Csvg height%3D'6.827in'  viewBox%3D'0 0 6.827 6.827' width%3D'6.827in' xmlns%3D'http://www.w3.org/2000/svg'%3E%3Cpath fill%3D'%238d6e4f' d%3D'M2.83373 4.08723c0.234571,-0.12152 0.468327,-0.242677 0.702075,-0.363862 0.229406,-0.118933 0.458823,-0.237913 0.689008,-0.357299 -0.255059,-0.133181 -0.508724,-0.265543 -0.762114,-0.397764 -0.209614,-0.109378 -0.419059,-0.218677 -0.628969,-0.328256l0 1.44718zm0.750823 -0.26928c-0.259551,0.134563 -0.51911,0.269091 -0.779783,0.404118l-0.0777087 0.040252 0 -0.0875433 0 -1.62249 0 -0.0877638 0.0779173 0.0406811c0.236012,0.123224 0.471343,0.246024 0.706886,0.368933 0.283362,0.147858 0.567059,0.295898 0.852677,0.445059l0.0905591 0.0472953 -0.0907677 0.0470787c-0.260673,0.135205 -0.520232,0.269819 -0.77978,0.404378z'/%3E%3Cpath fill%3D'%238d6e4f' d%3D'M5.83278 4.58511c-0.0327126,0.14115 -0.106701,0.263898 -0.20726,0.355248 -0.101142,0.091874 -0.229165,0.152126 -0.369209,0.16763 -0.305,0.0341142 -0.612587,0.0512874 -0.921185,0.0598937 -0.306618,0.00855118 -0.614535,0.00855118 -0.921929,0.00837402 -0.307256,0.000177165 -0.615177,0.000177165 -0.921839,-0.00837402 -0.308642,-0.0086063 -0.616319,-0.0257795 -0.921354,-0.0598937 -0.140071,-0.0155039 -0.268122,-0.0757756 -0.36922,-0.167677 -0.100508,-0.0913583 -0.174394,-0.214094 -0.206894,-0.355201 -0.0436378,-0.189098 -0.0654331,-0.386354 -0.0763071,-0.584752 -0.0109252,-0.199445 -0.0109291,-0.395992 -0.0109291,-0.586795 0,-0.191055 0.000279528,-0.387858 0.0114685,-0.587185 0.0111457,-0.198484 0.0332087,-0.395748 0.0768228,-0.584815 0.0323071,-0.141047 0.106157,-0.263748 0.206673,-0.35511 0.101157,-0.0919528 0.229335,-0.15226 0.369445,-0.167764 0.304996,-0.0341181 0.612673,-0.0512913 0.921315,-0.0599016 0.306665,-0.00855118 0.614587,-0.00855118 0.921799,-0.00837402 0.307256,-0.000177165 0.615197,-0.000177165 0.921823,0.00837402 0.308606,0.00861024 0.616193,0.0257835 0.921016,0.0599016 0.140244,0.0154961 0.268476,0.0757756 0.369728,0.167689 0.100626,0.0913504 0.174594,0.214075 0.207094,0.355185 0.0859488,0.37402 0.0859488,0.779492 0.0859409,1.16233l0.000208661 0 0 0.00967323 -0.000208661 0c1.5748e-005,0.192681 -7.48031e-005,0.391154 -0.0108425,0.586795 -0.0109134,0.19839 -0.0327126,0.395646 -0.0761575,0.584752zm-0.278929 0.2765c0.0849961,-0.0772126 0.147535,-0.180961 0.175181,-0.300248 0.0419449,-0.182579 0.0630433,-0.373945 0.0736535,-0.566839 0.0107638,-0.19563 0.0108543,-0.391161 0.0108425,-0.580961l-0.000208661 0 0 -0.00967323 0.000208661 0c3.93701e-006,-0.376594 7.87402e-006,-0.775457 -0.083437,-1.13858 -0.0274685,-0.119264 -0.0899803,-0.222992 -0.175016,-0.300185 -0.0849213,-0.0770866 -0.19235,-0.12763 -0.309728,-0.140602 -0.30328,-0.0339488 -0.607673,-0.0509882 -0.91226,-0.0594843 -0.306567,-0.00854724 -0.613094,-0.00854724 -0.918909,-0.00837402 -0.305772,-0.000173228 -0.61228,-0.000173228 -0.918886,0.00837402 -0.304618,0.00849606 -0.609102,0.0255394 -0.912559,0.0594843 -0.117224,0.0129724 -0.224587,0.0635433 -0.309445,0.140677 -0.0848898,0.0771614 -0.14728,0.180858 -0.174594,0.30011 -0.0421299,0.182626 -0.0634843,0.373984 -0.0743189,0.566902 -0.0107835,0.192075 -0.0110512,0.389496 -0.0110512,0.58135 0,0.191677 0,0.38913 0.0105118,0.580961 0.0105709,0.192882 0.0316654,0.384244 0.0738031,0.566839 0.0274724,0.119291 0.0899055,0.22302 0.174815,0.300201 0.0847992,0.0770866 0.192043,0.127618 0.30922,0.140591 0.303492,0.0339449 0.607976,0.0509843 0.912598,0.0594764 0.306602,0.00854724 0.61311,0.00854724 0.918925,0.00837402 0.305953,0.000173228 0.612457,0.000173228 0.919016,-0.00837402 0.304579,-0.00849213 0.608972,-0.0255354 0.912429,-0.0594764 0.117157,-0.0129724 0.224382,-0.0634882 0.309209,-0.140543z'/%3E%3C/svg%3E");
                background-size: contain;
                opacity: 0.5;
                will-change: opacity;
                transition: opacity 250ms ease-in-out;
                &:hover {
                  opacity: 1;
                }
              }
              .title {
                @include pubTitle;
                margin-bottom: 0.5rem;
              }
              .description {
                text-align: left;
                font-size: 0.9rem;
              }
              .source {
                position: absolute;
                left: 0.5rem;
                bottom: 0.5rem;
                height: 2rem;
                width: 2rem;
                background: no-repeat center;
                background-size: contain;
              }
              .date {
                position: absolute;
                bottom: 0.5rem;
                right: 0.5rem;
              }
              .duration {
                position: absolute;
                bottom: 0.5rem;
                left: 3rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.engage-wrap {
  .engage {
    .banner {
      .viewer {
        .single {
          //overflow: hidden;
          //transform: scale(0.9);
          //transform-origin: top left;
        }
      }
    }
  }
}
</style>
